// extracted by mini-css-extract-plugin
export default {"icon":"callActions_icon__JuFMB","callActionButton":"callActions_callActionButton__cTZ8A","contentLabel":"callActions_contentLabel__bcjzl"};